import { Feed } from './Feed';
import { useFeed } from './useFeed';
import { useSettings } from '../../platform/settings';
import { cx } from '../../ui';
import styles from './feed.module.css';
import layout from '../../ui/layout.module.css';

/**
 * The popular page — `/feed/popular`, and `/feed/trending` too since core aliases that path here.
 *
 * It was one component serving two pages until the Trending screen was retired. What is left of
 * Trending is a **section above** the popular one, drawn only when the reader has asked for it: same
 * heading, same sentence, same grid search, same grid, in reading order above everything the popular
 * page already showed.
 *
 * `useFeed` is called for both either way — hooks cannot be conditional — and the setting is passed to
 * the trending one as `enabled`, which is what keeps `/api/v1/trending` unrequested for the readers who
 * have the section switched off. That is the whole reason the flag reaches the query rather than only
 * the markup: this page is most people's landing page, and a request nobody sees the result of is worse
 * than an empty section.
 *
 * A `<div>` rather than a `<main>`: the shell owns that landmark, and two of them is a bug.
 */
export function FeedView() {
  const showTrending = useSettings().trendingOnPopular;
  const trending = useFeed('trending', { enabled: showTrending });
  const popular = useFeed('popular');

  return (
    // The frame from outside, the stack from this screen (docs/specs/web-ui.md) — and the stack matters
    // only when there are two sections to separate.
    <div className={cx(layout.wide, styles.page)}>
      {showTrending ? <Feed binding={trending} /> : null}
      <Feed binding={popular} />
    </div>
  );
}
